// ======================================================================
// File Name       : TopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import moment from 'moment';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import * as ModalAction from '../actions/ModalAction';
import * as topAction from '../actions/TopAction';
import ModalConductor from '../components/modal/ModalConductor';
import JoinableLiveList from '../components/usageSettingLive/JoinableLiveList';
import * as actionType from '../constants/actionTypes/page';
import { CONTACT_URL, DEFAULT_DATE_SHORT_FORMAT_SERVER, PAYMENT_URL, RETURN_MAX_NUM_TOP, SELECT_TARGET_DATA, SUPER_USER_SECERN_ID, USAGE_SETTING } from '../constants/index';
import * as ModalIds from '../constants/ModalIds';
import { SELECT_BOX_DATA } from '../constants/SelectBoxData';
import { SERVICE_TYPE } from '../constants/ServiceConstant';
import NoticeDetail from '../containers/top/NoticeDetail';
import NoticeForEnterpriseTop from '../containers/top/NoticeForEnterpriseTop';
import NoticeForServiceTop from '../containers/top/NoticeForServiceTop';
import SystemNoticeList from '../containers/top/SystemNoticeList';
import { handleDownload } from '../utils/index';
import RenderField from '../utils/ReduxFormUtils';
import { isSuperUser } from '../utils/UserUtils';
import TrialExpireNotice from './top/TrialExpireNotice';
import { TOKEN } from '../constants/LocalStorageConstants';
import { canAccessRoute } from '../utils/AuthedUtils';
import FUNCTION_AUTHORITY from '../constants/FunctionAuthConstants';
import { MATERIAL_DOWNLOAD } from '../constants/FunctionConstants';

class TopContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      systemNotice: {
        recordNum: 0,
        noticeList: [],
      },
      noticeEnterpriseId: null,
      noticeEnterprise: {},
      noticeServiceId: null,
      noticeList: [],
      noticeInfo: {},
      serviceNoticeList: [],
      showDialog: false,
      startPositionSystem: 0,
      startPositionEnterprise: 0,
      startPositionService: 0,
      returnMaxNum: RETURN_MAX_NUM_TOP,
      recordNumSystem: 0,
      recordNumEnterprise: 0,
      recordNumService: 0,
    };
    this.handleNoticeDetail = this.handleNoticeDetail.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.createParams = this.createParams.bind(this);
    this.getStartEndDataEnterprise = this.getStartEndDataEnterprise.bind(this);
    this.getStartEndDataService = this.getStartEndDataService.bind(this);
    this.getStartEndDataSystem = this.getStartEndDataSystem.bind(this);
    this.showDetailOfEnterpriseNotice = this.showDetailOfEnterpriseNotice.bind(this);
    this.showDetailofServiceNotice = this.showDetailofServiceNotice.bind(this);
    this.onClickDownload = this.onClickDownload.bind(this);
    this.handleDownloadSample = this.handleDownloadSample.bind(this);
    this.openPaymentUrl = this.openPaymentUrl.bind(this);
    this.openContactUrl = this.openContactUrl.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Sprint_20230508 #33 START
    const { isTrialExpire } = this.props.authed.authedUser;
    // sprint_20230522_tma START
    const { top, noticeForEnterpriseList, serviceNotice, service } = nextProps;
    const { systemNotice } = top;
    const recordNumSystem = systemNotice && systemNotice.recordNum ? systemNotice.recordNum : 0;
    if (!isTrialExpire) {
      const bySecernIdsEnterprise = noticeForEnterpriseList.noticeForEnterpriseList.bySecernId;
      const noticeList = Object.keys(bySecernIdsEnterprise).map(key => bySecernIdsEnterprise[key]);
      const recordNumEnterprise = noticeForEnterpriseList && noticeForEnterpriseList.noticeForEnterpriseList && noticeForEnterpriseList.noticeForEnterpriseList.recordNum ? noticeForEnterpriseList.noticeForEnterpriseList.recordNum : 0;
      const bySecernIdsService = serviceNotice.bySecernIds;
      const serviceNoticeList = Object.keys(bySecernIdsService).map(key => bySecernIdsService[key]);
      const recordNumService = service && service.serviceNotiRecordNum ? service.serviceNotiRecordNum : 0;
      this.setState({
        systemNotice,
        noticeList,
        serviceNoticeList,
        recordNumSystem,
        recordNumEnterprise,
        recordNumService,
      });
    }
    else {
      this.setState({
        systemNotice,
        recordNumSystem,
      });
    }
    // sprint_20230522_tma END
    // Sprint_20230508 #33 END
  }

  componentWillMount() {
    // Sprint_20230508 #33 START
    const { dispatch } = this.props;
    const { isTrialExpire } = this.props.authed.authedUser;
    if (isTrialExpire) {
      dispatch(topAction.getCurrentUsageStatus(this.props.authed.authedUser.userInfo.displayUserType));
      // sprint_20230522_tma START
      const paramForSystem = this.createParams(0, false);
      dispatch(topAction.getNoticeSystem(
        paramForSystem,
      ));
      // sprint_20230522_tma END
    } else {
      const paramForEnterprise = this.createParamsForEnterprise(0);
      const paramForService = this.createParams(0, true);
      const paramForSystem = this.createParams(0, false);
      dispatch(topAction.doNotificeList(
        paramForEnterprise,
        paramForService,
        paramForSystem,
        this.props.authed.authedUser.userInfo.displayUserType,
      ));
    }
    dispatch({
      type: actionType.CLEAR_SEARCH_CONDITION,
    });
    // Sprint_20230508 #33 END
  }

  componentDidMount() {
    const { authedUser } = this.props;
    const token = authedUser ? authedUser.token : localStorage.getItem(TOKEN);
    window.saveToken(token);
    window.sendToken(token);
  }

  createParams(startPosition, isServiceNotice) {
    const { userSecernId, displayUserType, representationUserSecernId } = this.props.authed.authedUser.userInfo;
    const now = moment().format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
    const param = {
      selectTargetData: 0,
      searchInfo: isServiceNotice ?
      {
        // Step 11.0.0 START
        user_list: isSuperUser(displayUserType) ? Array.of(SUPER_USER_SECERN_ID, representationUserSecernId) : [userSecernId],
        // Step 11.0.0 END
        publicDateFrom: now,
        publicDateTo: now,
        public_status: 1,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM_TOP,
      }
      :
      {
        startPosition,
        returnMaxNum: RETURN_MAX_NUM_TOP,
      },
    };
    return param;
  }

  createParamsForEnterprise(startPosition) {
    const now = moment().format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
    const param = {
      institutionId: this.props.authed.authedUser.institutionId,
      selectTargetData: 0,
      searchInfo: {
        publicDateFrom: now,
        publicDateTo: now,
        public_status: 1,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM_TOP,
      },
    };
    return param;
  }

  /**
   * handle when click on notice title
   * @param {*} notice
   */
  handleNoticeDetail(notice) {
    this.setState({ noticeInfo: notice, showDialog: true });
  }

  /**
   * handle Ok button on dialog
   */
  handleCloseDialog() {
    this.setState({
      showDialog: false,
    });
  }

  getStartEndDataEnterprise(startPositionEnterprise) {
    this.setState(
      {
        startPositionEnterprise,
      },
      () => {
        const paramForEnterprise = this.createParamsForEnterprise(startPositionEnterprise);
        this.props.dispatch(topAction.getNoticeEnterprise(paramForEnterprise, this.props.authed.authedUser.userInfo.displayUserType));
      },
    );
  }
  getStartEndDataService(startPositionService) {
    this.setState(
      {
        startPositionService,
      },
      () => {
        const paramForService = this.createParams(startPositionService, true);
        this.props.dispatch(topAction.getNoticeService(paramForService));
      },
    );
  }
  getStartEndDataSystem(startPositionSystem) {
    this.setState(
      {
        startPositionSystem,
      },
      () => {
        const paramForSystem = this.createParams(startPositionSystem, false);
        this.props.dispatch(topAction.getNoticeSystem(paramForSystem));
      },
    );
  }

  showDetailOfEnterpriseNotice(noticeForEnterprise) {
    this.props.dispatch(topAction.getNoticeEnterpriseDetail(noticeForEnterprise)).then(() => {
      this.props.dispatch(ModalAction.openModal(ModalIds.ENTERPRISE_NOTICE_DETAIL));
    });
  }

  showDetailofServiceNotice(noticeForService) {
    this.props.dispatch(topAction.getNoticeServiceDetail(noticeForService)).then(() => {
      this.props.dispatch(ModalAction.openModal(ModalIds.SERVICE_NOTICE_DETAIL));
    });
  }

  onClickDownload(url) {
    this.setState({ showDialog: false });
    return handleDownload(url, '');
  }
  handleDownloadSample() {
    const { formValues } = this.props;
    if (formValues && formValues.sampleDownload) {
      const link = document.createElement('a');
      document.body.appendChild(link);
      link.href = formValues.sampleDownload;
      link.click();
      document.body.removeChild(link);
    }
  }

  // Sprint_20230508 #33 START
  openPaymentUrl() {
    const newPage = window.open(`${PAYMENT_URL}`, '_blank');
    newPage.focus();
  }

  openContactUrl() {
    const newPage = window.open(`${CONTACT_URL}`, '_blank');
    newPage.focus();
  }

  render() {
    const { joinableLives, authed, maxIdTotalNum, maxMultiLanguageDocumentPage, editingEnterprise } = this.props;
    const { authedUser } = authed;
    const { serviceType, isTrialExpire } = authedUser;
    const canAccessDownloadItem = canAccessRoute(MATERIAL_DOWNLOAD); // Step 10.0.0
    // Step 10.2.0 START
    const { usageSettingLive } = authedUser;
    const isUseUsageSettingLive = usageSettingLive === USAGE_SETTING.USE;
    // Step 10.2.0 END
    const { creditCheckedFlag } = editingEnterprise;

    return (
      <div>
        {!isTrialExpire && (
          <>
            {/* #6466 START */}
            {/* sprint_20230508_#30 START */}
            {/* Step 10.0.0 START */}
            {canAccessDownloadItem && (
              <Row sm={12} className="margin-bottom-20 padding-left-right-clear display-flex justify-content-end">
                <Col sm={3}>
                  <RenderField
                    type="selectbox"
                    name="sampleDownload"
                    label="ステータス"
                    data={SELECT_BOX_DATA.SAMPLE_DOWNLOAD}
                    className="float-end"
                  />
                </Col>
                <Col xs="auto" className="ps-0">
                  <Button className="btn btn-primary" onClick={this.handleDownloadSample}>ダウンロード</Button>
                </Col>
              </Row>
            )}
            {/* Step 10.0.0 END */}
            {/* sprint_20230508_#30 END */}
            {/* #6466 END */}
            {/* Step 10.2.0 START */}
            {/* {serviceType === SERVICE_TYPE.CONTENT_DISTRIBUTION || !isUseUsageSettingLive ? null : (
              <JoinableLiveList {...joinableLives} />
            )} */}
            {/* Step 10.2.0 END */}
            <SystemNoticeList
              systemNotice={this.state.systemNotice}
              onHandleNoticeDetail={this.handleNoticeDetail}
              startPositionSystem={this.state.startPositionSystem}
              getStartEndDataSystem={this.getStartEndDataSystem}
              recordNumSystem={this.state.recordNumSystem}
            />
            <NoticeDetail
              noticeInfo={this.state.noticeInfo}
              showDialog={this.state.showDialog}
              onHandleCloseDialog={this.handleCloseDialog}
              onClickDownload={this.onClickDownload}
            />
            <NoticeForEnterpriseTop
              noticeList={this.state.noticeList}
              onHandleNoticeDetail={this.showDetailOfEnterpriseNotice}
              startPositionEnterprise={this.state.startPositionEnterprise}
              getStartEndDataEnterprise={this.getStartEndDataEnterprise}
              recordNumEnterprise={this.state.recordNumEnterprise}
            />
            <NoticeForServiceTop
              noticeList={this.state.serviceNoticeList}
              onHandleNoticeDetail={this.showDetailofServiceNotice}
              startPositionService={this.state.startPositionService}
              getStartEndDataService={this.getStartEndDataService}
              recordNumService={this.state.recordNumService}
            />
            <ModalConductor
              noticeEnterprise={this.props.noticeEnterprise}
              noticeService={this.props.noticeService}
              history={this.props.history}
              serviceDetailUserList={this.props.serviceDetailUserList}
            />
          </>
        )}
        {isTrialExpire && (
          <TrialExpireNotice
            openPaymentUrl={this.openPaymentUrl}
            openContactUrl={this.openContactUrl}
            idNum={maxIdTotalNum}
            multiLanguagePageNum={maxMultiLanguageDocumentPage}
            // sprint_20230522_tma START
            systemNotice={this.state.systemNotice}
            onHandleNoticeDetail={this.handleNoticeDetail}
            startPositionSystem={this.state.startPositionSystem}
            getStartEndDataSystem={this.getStartEndDataSystem}
            recordNumSystem={this.state.recordNumSystem}
            noticeInfo={this.state.noticeInfo}
            showDialog={this.state.showDialog}
            onHandleCloseDialog={this.handleCloseDialog}
            onClickDownload={this.onClickDownload}
            // sprint_20230522_tma END
            creditCheckedFlag={creditCheckedFlag}
          />
        )}
      </div>
    );
  }
  // Sprint_20230508 #33 END
}

const mapStateToProps = (state) => {
  const initialFormValue = {
    sampleDownload: SELECT_BOX_DATA.SAMPLE_DOWNLOAD[0].value,
  };
  return {
    authed: state.authed,
    top: state.top,
    noticeForEnterpriseList: state.enterpriseNotification,
    serviceNotice: state.service.serviceNotice,
    service: state.service,
    noticeEnterprise: state.top.noticeEnterprise,
    noticeService: state.top.noticeService,
    serviceDetailUserList: state.top.serviceDetailUserList,
    joinableLives: state.usageSettingLive.joinableLives,
    formValues: getFormValues('topFormContainer')(state),
    initialValues: initialFormValue,
    maxIdTotalNum: state.usageStatus.maxIdTotalNum,
    maxMultiLanguageDocumentPage: state.usageStatus.maxMultiLanguageDocumentPage,
    editingEnterprise: state.enterprise.editingEnterprise,
  };
};
export default connect(mapStateToProps)(reduxForm({
  form: 'topFormContainer', // a unique identifier for this form
  touchOnChange: true,
})(TopContainer));
